const {
  mainConfigService,
  applePayConfigService,
  googlePayConfigService,
  samsungPayConfigService,
} = require('./services/config');
const {
  getFailedModalHtml,
  checkResponseStatus3ds,
  checkResponseStatusSuccess,
  checkResponseStatusCanceled,
  checkResponseStatusError,
  checkResponseStatusFailed,
  setMethod,
  resetAllSavedCards,
  getApplePayHtml,
  checkFormsofPayments,
  resetSelectedCheckboxes,
  phoneNumberSetSpace,
  getFeesHtml,
  getSaveCardCheckbox,
  getWalletButtonsHtml,
  calculateSubTotal,
  getMobilePayModal,
  getMobilePayOTPModal,
  getRejectModalHtml,
  validateMobilePayFields,
  handleApplePayStyles,
  handleMobilePayStyles,
  findPaymentConfig,
  getPopupModalHtml,
  getTotalAmountHtml,
} = require('./util');
const { paymentProcessingLoader, loyaltySectionHtml, loyaltyBillingSummaryHtml } = require('./html');

const { $t, $payButtonText } = require('./translate');
const {
  redirectPayFetch,
  deleteTokenFetch,
  sendMobilePayOtp,
  submitMobilePayOTP,
  fetchInstallmentOptions,
  cancelPayFetch,
  getCheckoutPageStatus,
  walletSubmitFetch,
} = require('./http');

const AbaPaywayIntegration = require('./integrations/AbaPaywayIntegration');
const CsucIntegration = require('./integrations/CsucIntegration');
const DokuIntegration = require('./integrations/DokuIntegration');
const GeideaIntegration = require('./integrations/GeideaIntegration');
const { JazzIntegration } = require('./integrations/JazzIntegration');

const { elements, method, SDK_FOPS, logoSvg } = require('./variables');
const { PAYMENT_TYPES, THREEDS_METHODS, LANGUAGES } = require('./constants');
const { FRIEND_PAY_SELECTORS } = require('./constant/friendPayConstants');
const { PayButtonEventListenerService, ThreeDSService, SessionSocketService } = require('./services');
const { initializeGooglePayServices, onGooglePayLoaded } = require('./googlePay');
const { formatAmountDisplay, formatFeeDisplay } = require('./utils/billing');
const { initializeApplePayServices, _applePayAvailable,_isWalletActive } = require('./apple');
const { escapeHtml } = require('./security');
const { TokenPaymentFlow } = require('./paymentFlows');
const { initializeSamsungPayServices, loadSamsungPay } = require('./samsungPay');
const FriendPayService = require('./services/FriendPayService');
const WalletService = require('./services/WalletService');
const { LoyaltyService } = require('./services/loyaltyService');
const { friendPaySheetModal, friendPaySendSheet, friendPayStatusModal, friendPayStatusLoadingModal } = require('./html');
const { extractCardDataFromMethod } = require('./utils/cardDataExtractor');

class Selector {
  static currentSelectOperation = null;
  static _previouslySelectedElement = null;
  static _sessionSocketService = null;
  static loyaltyService = null;


  static setSelector(selector) {
    this.documentCheckout = selector;
  }

  static setCurrentScript(currScript) {
    this.curScriptElement = currScript;
  }

  static initializeServices(callBackService, fieldsService) {
    this.fieldsService = fieldsService;
    this.callbackService = callBackService;

    this.tokenPaymentFlow = new TokenPaymentFlow(
      this.documentCheckout,
      callBackService
    );

    const threeDSService = new ThreeDSService(Selector.documentCheckout, callBackService, fieldsService);
    this.threeDSService = threeDSService;

    // Initialize friend pay service
    this.friendPayService = new FriendPayService(this.documentCheckout);

    // Initialize wallet service
    if (checkFormsofPayments('wallet')) {
      this.walletService = new WalletService(this.documentCheckout, callBackService, {
        updatePayButton: (amount) => Selector._updatePayButton(amount),
        changeTotal: (...args) => Selector.changeTotal(...args),
        setPayButtonDisabled: (disabled) => Selector._setPayButtonDisabled(disabled),
        refreshSelectedMethodData: (element) => Selector.selectePayMethod(element),
        showErrorPopup: (message) => Selector.showModal(getFailedModalHtml(message, $t('Wallet Error')), null, 'info'),
        filterMethodsByCurrency: (walletCurrencyCode) => Selector._filterMethodsByCurrency(walletCurrencyCode),
        onFullCoverageChange: (isFull) => Selector._setOtherMethodsDisabled(isFull),
      });
    }

    // Initialize loyalty service
    this.loyaltyService = new LoyaltyService(this.documentCheckout);

    // TODO:: Implement DI in the SDK
    initializeGooglePayServices(callBackService, threeDSService, Selector.validatePayment);
    initializeApplePayServices(callBackService);
    initializeSamsungPayServices(callBackService, {
      showLoader: Selector.showPaymentProcessingLoader,
      hideLoader: Selector.hidePaymentProcessingLoader,
    }, Selector.validatePayment);
  }


  constructor() {
    this.abaIntegration = undefined;
    this.csucIntegration = undefined;
    this.dokuIntegration = undefined;
    this.geideaIntegration = undefined;
    this.callbackService = undefined;
    this.fieldsService = undefined;
    this.threeDSService = undefined;
  }

  static escKeyListener = null;
  static jazzIntegration = null;


  static _updatePayButton(amountWithCurrency) {
    const payButton = this.documentCheckout.querySelector(`#${elements.payButton}`);
    if (payButton) {
      const buttonSpan = payButton.querySelector('span');
      if (buttonSpan) {
        buttonSpan.innerHTML = `${$payButtonText()} (${amountWithCurrency})`;
      }
    }
  }

  static _setOtherMethodsDisabled(disabled) {
    const doc = Selector.documentCheckout;
    if (!doc) return;

    Selector._bypassSavedTokenTransition();

    doc.querySelectorAll(`.${elements.accordionItemRadio}`).forEach(radio => {
      if (radio.getAttribute('data-is_expired') === 'true') return;
      if (!disabled && radio.getAttribute('data-wallet-currency-disabled') === 'true') return;
      radio.disabled = disabled;
      const label = radio.nextElementSibling;
      if (label) label.classList.toggle('ottu__sdk-disabled', disabled);
    });

    doc.querySelectorAll(`.${elements.accordionItem}`).forEach(item => {
      if (!disabled && item.getAttribute('data-wallet-currency-disabled') === 'true') return;
      item.classList.toggle('ottu__sdk-disabled', disabled);
    });

    if (disabled) {
      // Save the currently selected element so it can be restored when wallet is deactivated
      // Only overwrite if we find something — _filterMethodsByCurrency may have already saved
      // the element if it ran first and deselected a currency-incompatible method
      const checkedRadio = doc.querySelector(`.${elements.accordionItemRadio}:checked`);
      const selectedPayMethod = doc.querySelector(`.${elements.paymentMethod}.ottu__sdk-border-green`);
      const found = checkedRadio || selectedPayMethod;
      if (found) Selector._previouslySelectedElement = found;

      // Clear any currently selected method/card state
      Selector.unselectMethod();

      // Hide any visible card iframe wrapper (e.g. ottu_pg jazz-sdk iframe)
      doc.querySelectorAll('.ottu__sdk-card-iframe-wrapper').forEach((el) => {
        el.classList.remove('show');
        el.classList.remove('ottu__sdk-selected-method-theme');
      });

      // Remove selection highlight from accordion items and payment methods
      doc.querySelectorAll(`.${elements.accordionItem}, .${elements.paymentMethod}`).forEach(el => {
        el.classList.remove('ottu__sdk-border-green');
        el.classList.remove('ottu__sdk-onsite-method');
      });

      // Collapse open CVV containers, uncheck saved card radios, hide delete buttons
      doc.querySelectorAll('.ottu__sdk-radio-div').forEach(radioDiv => {
        const input = radioDiv.querySelector('input');
        if (input) input.checked = false;
        radioDiv.querySelectorAll('.d-flex').forEach(el => el.classList.remove('d-flex'));
        const deleteBtn = radioDiv.querySelector(`.${elements.saveCardDeleteButton}`);
        if (deleteBtn) deleteBtn.style.display = '';
      });

      // Clear any CVV text input values
      resetAllSavedCards(doc.querySelectorAll('.ottu__sdk-input-ccv'));

      // Hide all service-specific button blocks and switch to the SDK pay button
      Selector.hideAllButtons(doc, elements);
      doc.querySelector('.wallet-buttons')?.classList.add('d-none');

      const payButton = doc.querySelector(`#${elements.payButton}`);
      if (payButton) {
        payButton.classList.remove('d-none');
        payButton.classList.remove('ottu__sdk-disabled-pay-button');
        payButton.removeAttribute('disabled');
        payButton.addEventListener('click', Selector.payButtonClick);
      }
    } else {
      // Restore the previously selected method if it isn't currency-disabled
      const prev = Selector._previouslySelectedElement;
      if (prev && prev.getAttribute('data-wallet-currency-disabled') !== 'true' && prev.getAttribute('data-is_expired') !== 'true') {
        Selector._previouslySelectedElement = null;
        if (prev.type === 'radio') prev.checked = true;
        Selector.selectePayMethod(prev);
      }
      // If prev is currency-disabled, leave it set for _filterMethodsByCurrency(null) to restore
    }
  }

  static _bypassSavedTokenTransition() {
    const savedTokens = Selector.documentCheckout?.querySelectorAll('.ottu__sdk-saved-tokens');
    if (!savedTokens) return;
    savedTokens.forEach(el => { el.style.transition = 'none'; });
    requestAnimationFrame(() => savedTokens.forEach(el => { el.style.transition = ''; }));
  }

  static _resolveMethodDisabled(el, walletCurrencyCode) {
    const name = el.getAttribute('name');
    const type = el.getAttribute('data-type');
    const code = name ? el.getAttribute(name) : null;
    const methodType = el.getAttribute('data-method_type') || '';
    if (!code) return null;

    const configData = Selector._lookupMethodData(code, type, methodType);
    const methodCurrency = configData?.currency_code;
    return !!(walletCurrencyCode && methodCurrency && methodCurrency !== walletCurrencyCode);
  }

  static _filterMethodsByCurrency(walletCurrencyCode) {
    const doc = Selector.documentCheckout;
    if (!doc) return;

    Selector._bypassSavedTokenTransition();

    let didDeselect = false;

    doc.querySelectorAll(`.${elements.paymentMethod}`).forEach(el => {
      const shouldDisable = Selector._resolveMethodDisabled(el, walletCurrencyCode);
      if (shouldDisable === null) return;

      el.classList.toggle('ottu__sdk-disabled', shouldDisable);
      el.setAttribute('data-wallet-currency-disabled', shouldDisable ? 'true' : 'false');

      if (shouldDisable && el.classList.contains('ottu__sdk-border-green')) {
        Selector._previouslySelectedElement = el;
        el.classList.remove('ottu__sdk-border-green');
        el.classList.remove('ottu__sdk-onsite-method');
        const key = el.id?.replace('method', '');
        const iframeWrapper = key && doc.querySelector(`#iframe-container-${key} .ottu__sdk-card-iframe-wrapper`);
        if (iframeWrapper) {
          iframeWrapper.classList.remove('show');
          iframeWrapper.classList.remove('ottu__sdk-selected-method-theme');
        }
        didDeselect = true;
      }
    });

    doc.querySelectorAll(`.${elements.accordionItemRadio}`).forEach(radio => {
      if (radio.getAttribute('data-is_expired') === 'true') return;

      const shouldDisable = Selector._resolveMethodDisabled(radio, walletCurrencyCode);
      if (shouldDisable === null) return;

      radio.disabled = shouldDisable;
      radio.setAttribute('data-wallet-currency-disabled', shouldDisable ? 'true' : 'false');
      const label = radio.nextElementSibling;
      if (label) label.classList.toggle('ottu__sdk-disabled', shouldDisable);

      if (shouldDisable && radio.checked) {
        Selector._previouslySelectedElement = radio;
        radio.checked = false;
        const radioDiv = radio.closest('.ottu__sdk-radio-div');
        if (radioDiv) {
          radioDiv.querySelectorAll('.d-flex').forEach(el => el.classList.remove('d-flex'));
          const deleteBtn = radioDiv.querySelector(`.${elements.saveCardDeleteButton}`);
          if (deleteBtn) deleteBtn.style.display = '';
        }
        didDeselect = true;
      }
    });

    doc.querySelectorAll(`.${elements.accordionItem}`).forEach(item => {
      const radio = item.querySelector(`.${elements.accordionItemRadio}`);
      if (!radio || radio.getAttribute('data-is_expired') === 'true') return;
      item.classList.toggle('ottu__sdk-disabled', radio.disabled && !!walletCurrencyCode);
    });

    if (didDeselect) {
      Selector.unselectMethod();

      const walletBilling = Selector.walletService && Selector.walletService.getWalletServiceBilling();
      const currencyCode = mainConfigService.get('currency_code') || '';
      const amount = mainConfigService.get('amount') || '';

      if (walletBilling) {
        Selector.changeTotal('', currencyCode, currencyCode, amount, '', {
          amount: walletBilling.remaining || walletBilling.wallet_amount,
          original_amount: walletBilling.amount,
        });
      } else {
        Selector.changeTotal('', currencyCode, currencyCode, amount, '', mainConfigService.get('billing') || null);
      }
    }
    
     // Restore a previously selected method that was currency-disabled by the wallet
    if (!walletCurrencyCode && Selector._previouslySelectedElement) {
      const prev = Selector._previouslySelectedElement;
      Selector._previouslySelectedElement = null;
      if (prev.getAttribute('data-is_expired') !== 'true') {
        if (prev.type === 'radio') prev.checked = true;
        Selector.selectePayMethod(prev);
      }
    }
  }

  static _setPayButtonDisabled(disabled) {
    const payButton = this.documentCheckout.querySelector(`#${elements.payButton}`);
    if (!payButton) return;

    if (disabled) {
      payButton.classList.add('ottu__sdk-disabled-pay-button');
      payButton.setAttribute('disabled', 'true');
    } else {
      payButton.classList.remove('ottu__sdk-disabled-pay-button');
      payButton.removeAttribute('disabled');
    }
  }

  static _updateAmountElements(displayAmount, currencyLabel) {
    const amountElements = this.documentCheckout.querySelectorAll(`.${elements.amount}`);
    const currencyElements = this.documentCheckout.querySelectorAll(`.${elements.currency}`);

    amountElements.forEach(element => {
      element.innerHTML = displayAmount;
    });

    currencyElements.forEach(element => {
      element.innerHTML = currencyLabel;
    });
  }

  static _updateFeesDisplay(feeData, description) {
    const feesBlock = this.documentCheckout.querySelector(`#${elements.feesBlock}`);

    if (!feesBlock) return;

    feesBlock.innerHTML = getFeesHtml();

    const feeLabels = this.documentCheckout.querySelectorAll(`.${elements.feesLabel}`);
    const feesElement = this.documentCheckout.querySelector(`.${elements.fees}`);
    const feesCurrencyElement = this.documentCheckout.querySelector(`.${elements.feesCurrency}`);

    feeLabels.forEach(element => {
      if (feeData.feeLabel) {
        element.innerHTML = feeData.feeLabel;
      } else if (description) {
        element.innerHTML = description;
      } else {
        element.innerHTML = $t('Applied Fees');
      }
    });

    if (feesElement) {
      feesElement.innerHTML = feeData.displayFee;
    }

    if (feesCurrencyElement) {
      feesCurrencyElement.innerHTML = feeData.feeCurrency;
    }
  }

  static _lookupBilling(code, type, methodType) {
    if (type === 'save') {
      const methods = mainConfigService.get('payment_methods') || [];
      return methods.find(m => m.code === code)?.billing || null;
    }

    if (methodType === 'payment_service') {
      const services = mainConfigService.get('payment_services') || [];
      return services.find(m => m.code === code)?.billing || null;
    }

    if (methodType === 'flex_method') {
      const flexMethods = mainConfigService.get('flex_methods') || [];
      return flexMethods.find(m => m.code === code)?.billing || null;
    }

    const methods = mainConfigService.get('payment_methods') || [];
    return methods.find(m => m.code === code)?.billing || null;
  }

  static _lookupMethodData(code, type, methodType) {
    if (type === 'save') {
      const cards = mainConfigService.get('cards') || [];
      const card = cards.find(c => c.token === code);
      if (!card) return null;

      // A saved card's parent PG can live in either collection — wallet-backed
      // PGs (e.g. STC/UR Pay) are moved into payment_services during
      // normalization (see handleWalletConfigs). Mirror the original
      // payment_methods || payment_services resolution so fee/amount/currency
      // and the parent-derived ottu_pg fields don't blank out.
      const methods = mainConfigService.get('payment_methods') || [];
      const services = mainConfigService.get('payment_services') || [];
      const parent = methods.find(m => m.code === card.pg_code) ||
        services.find(m => m.code === card.pg_code);

      return {
        submit_url: card.submit_url || '',
        redirect_url: '',
        payment_url: '',
        cancel_url: '',
        direct_payment_url: parent?.direct_payment_url || '',
        trandata: parent?.trandata || '',
        fee: parent?.fee || '',
        amount: parent?.amount || '',
        currency_code: parent?.currency_code || '',
        description: parent?.fee_description || '',
        gateway: card.pg_name || card.pg || '',
        ccv_required: card.cvv_required || false,
        can_save_card: false,
        use_as_jazz_sdk: parent?.use_as_jazz_sdk || false,
        card_pg: card.pg_code || '',
        brand: card.brand || '',
        number: card.number || '',
        expiry_month: card.expiry_month || '',
        expiry_year: card.expiry_year || '',
        bin: card.bin || '',
      };
    }

    let m;
    if (type === 'wallet' && !methodType) {
      // STC/UR Pay buttons carry data-type="wallet" with no data-method_type,
      // so methodType is empty here. Their config is resolved from
      // payment_services first, then payment_methods as a fallback — mirroring
      // how the buttons are rendered (see checkout.js STC/UR Pay setup).
      const services = mainConfigService.get('payment_services') || [];
      const methods = mainConfigService.get('payment_methods') || [];
      m = services.find(item => item.code === code) ||
        methods.find(item => item.code === code);
    } else {
      let source;
      if (methodType === 'payment_service') {
        source = mainConfigService.get('payment_services') || [];
      } else if (methodType === 'flex_method') {
        source = mainConfigService.get('flex_methods') || [];
      } else {
        source = mainConfigService.get('payment_methods') || [];
      }
      m = source.find(item => item.code === code);
    }
    if (!m) return null;

    return {
      submit_url: m.submit_url || '',
      redirect_url: m.redirect_url || '',
      payment_url: m.payment_url || '',
      cancel_url: m.cancel_url || '',
      direct_payment_url: m.direct_payment_url || '',
      trandata: m.trandata || '',
      fee: m.fee || '',
      amount: m.amount || '',
      currency_code: m.currency_code || '',
      description: m.fee_description || '',
      gateway: m.pg || '',
      ccv_required: m.cvv_required || false,
      can_save_card: m.can_save_card || false,
      use_as_jazz_sdk: m.use_as_jazz_sdk || false,
      card_pg: '',
      brand: '',
      number: '',
      expiry_month: '',
      expiry_year: '',
      bin: '',
    };
  }

  static _clearFeesDisplay() {
    const feesBlock = this.documentCheckout.querySelector(`#${elements.feesBlock}`);
    if (feesBlock) {
      feesBlock.innerHTML = '';
    }
  }

  static changeTotal(fee, currencyCode, currencyCodedDefault, amount, description, billing = null) {
    const lang = mainConfigService.get('lang') || LANGUAGES.EN;

    const amountData = formatAmountDisplay(billing, amount, currencyCode, currencyCodedDefault, lang);

    this._updatePayButton(amountData.amountWithCurrency);

    const sectionDisplayAmount = amountData.originalAmountDisplay || amountData.displayAmount;

    if (fee > 0) {
      const feeData = formatFeeDisplay(billing, fee, amountData.currencyLabel, lang, currencyCode, currencyCodedDefault);

      if (amountData.useBillingFormat) {
        const singleAmountElement = this.documentCheckout.querySelector(`.${elements.amount}`);
        const singleCurrencyElement = this.documentCheckout.querySelector(`.${elements.currency}`);

        if (singleAmountElement) singleAmountElement.innerHTML = sectionDisplayAmount;
        if (singleCurrencyElement) singleCurrencyElement.innerHTML = amountData.currencyLabel;
      } else {
        const calculatedAmount = calculateSubTotal(amount, fee);
        const singleAmountElement = this.documentCheckout.querySelector(`.${elements.amount}`);
        const singleCurrencyElement = this.documentCheckout.querySelector(`.${elements.currency}`);

        if (singleAmountElement) singleAmountElement.innerHTML = calculatedAmount;
        if (singleCurrencyElement) singleCurrencyElement.innerHTML = amountData.currencyLabel;
      }

      this._updateFeesDisplay(feeData, description);
    } else {
      this._updateAmountElements(sectionDisplayAmount, amountData.currencyLabel);
      this._clearFeesDisplay();
    }
  }

  static handleSessionRefresh(data) {
    // Payer feedback: pulse the amount element
    const doc = Selector.documentCheckout;
    if (!doc) return;

    const _selected = doc.querySelector(`.${elements.accordionItemRadio}:checked`) ||
      doc.querySelector(`.${elements.paymentMethod}.ottu__sdk-border-green`);

    if (_selected) {
      Selector.refreshSelectedMethodData(_selected);
    } else if (data.amount && data.currency_code) {
      Selector.changeTotal('', data.currency_code, data.currency_code, data.amount, '', data.billing || null);
    }

    const amountEl = doc.querySelector('.ottu__sdk-amount-theme');
    if (amountEl) {
      amountEl.classList.remove('ottu__sdk-amount-updated');
      void amountEl.offsetWidth; // force reflow to restart animation
      amountEl.classList.add('ottu__sdk-amount-updated');
    }

    // Announce to screen readers via aria-live region — mirror the already-rendered amount
    const liveRegion = doc.querySelector('#ottu-amount-live');
    if (liveRegion && data.amount && data.currency_code) {
      liveRegion.textContent = data.billing?.amount?.display || `${data.currency_code} ${data.amount}`;
    }
  }

  static closeSessionSocket() {
    if (Selector._sessionSocketService) {
      Selector._sessionSocketService.close();
      Selector._sessionSocketService = null;
    }
  }

  static connectSessionSocket(wsUrl, sessionId, merchantId) {
    Selector.closeSessionSocket();
    Selector._sessionSocketService = new SessionSocketService({
      onRefresh: (refreshed) => Selector.handleSessionRefresh(refreshed),
    });
    Selector._sessionSocketService.connect({ wsUrl, sessionId, merchantId });
  }

  static renderOnlyApplePay() {
    this.documentCheckout
      .querySelectorAll('.card-only-display')
      .forEach((element) => {
        element.style.display = 'none';
      });
    this.documentCheckout.querySelector('.ottu__sdk-main').style.padding =
      '0px';
  }


  static refreshSelectedMethodData(element) {
    const name = element.getAttribute('name');
    const type = element.getAttribute('data-type');
    const code = element.getAttribute(name);
    const id = element.getAttribute('id') || '';
    const methodType = element.getAttribute('data-method_type') || '';
    const sub_option_value = element.getAttribute('data-sub_option_value') || '';

    const configData = Selector._lookupMethodData(code, type, methodType);
    if (!configData) return;

    const currencyCodedDefault = mainConfigService.get('currency_code') || '';

    setMethod(
      name, code, configData.submit_url, configData.cancel_url,
      configData.redirect_url, configData.payment_url, id,
      configData.ccv_required, configData.can_save_card,
      configData.amount, configData.currency_code,
      configData.gateway, configData.card_pg,
      configData.direct_payment_url, configData.trandata,
      sub_option_value, configData.brand, configData.number,
      configData.expiry_month, configData.expiry_year, configData.bin
    );

    const walletBillingKey = configData.card_pg || code;
    const billing = Selector._lookupBilling(walletBillingKey, type, methodType);
    const activeBilling = (Selector.walletService && Selector.walletService.isActive())
      ? (Selector.walletService.getWalletBilling(walletBillingKey) || billing)
      : billing;

    Selector.changeTotal(
      configData.fee, configData.currency_code,
      currencyCodedDefault, configData.amount, configData.description, activeBilling
    );

    if (Selector.walletService && Selector.walletService.isActive()) {
      Selector.walletService.updateWalletDetailsForMethod(walletBillingKey);
    }
  }

  static async payButtonClick() {
    if (!Selector.fieldsService.getDisableState()) {
      try {
        const isValid = await Selector.validatePayment();
        if (isValid === false) {
          return; // stop execution if the validate promise rejects;
        }

        // Wallet full coverage — skip normal payment flow
        if (Selector.walletService && Selector.walletService.isFullCoverage()) {
          await Selector._walletSubmitPay();
          return;
        }

        // Loyalty full coverage — skip normal payment flow
        if (Selector.loyaltyService && Selector.loyaltyService.isConfirmed() && Selector.loyaltyService.isFullCoverage()) {
          await Selector._loyaltySubmitPay();
          return;
        }

        if (method.type == 'token') {
          if (method.ccv_required) {
            Selector._handleCVVTokenPayment(method);
          } else {
            try {
              // Extract card data using standardized utility
              const card = extractCardDataFromMethod(method);

              // Call beforePayment callback with card data (both formats for backward compatibility)
              await Selector.callbackService.callBackPayment({ card });
              Selector._handleTokenPayment(method);
            } catch (error) {
              // Error from beforePayment callback - payment blocked
              Selector.fieldsService.disableEnableFields(false);
              Selector.showModal(
                getFailedModalHtml(error.message || 'Payment cancelled', $t('Error')),
                null,
                'info'
              );
            }
          }
        } else if (method.type == SDK_FOPS.OTTU_PG) {
          Selector._onsitePay();
        } else if (method.type == SDK_FOPS.REDIRECT || method.type == SDK_FOPS.TAMARA || method.type == SDK_FOPS.TABBY || method.type == SDK_FOPS.TALY) {
          Selector._redirectPay();
        } else if (method.type === SDK_FOPS.FRIEND_PAY) {
          // Show Friend Pay sheet
          Selector.showFriendPaySheet();
        } else if (method.type === 'aba_payway') {
          Selector._payAbaWay();
        } else if (method.type === 'doku') {
          Selector._payDoku();
        } else if (method.type === 'csuc') {
          Selector._payCsuc();
        } else if (method.type === 'geidea') {
          Selector._payGeidea();
        }
      } catch (error) {
        // Error from validation callback
        console.error('Payment validation failed:', error);
      }
    }
  }

  static validatePayment() {
    const termsConfig = mainConfigService.get('termsAndConditions');
    if (termsConfig.enabled && termsConfig.required) {
      const termsCheckbox = Selector.documentCheckout.querySelector('#' + elements.termsCheckbox);
      if (termsCheckbox && !termsCheckbox.checked) {
        Selector.showModal(
          getPopupModalHtml('alert', $t('Accept Terms and Conditions to continue the payment')),
          null,
          'info'
        );
        return Promise.resolve(false);
      }
    }
    return Selector.callbackService.callBackValidate();
  }

  static cancelButtonClick() {
    if (!Selector.fieldsService.getDisableState()) {
      Selector.showCancelModal(getRejectModalHtml())
    }
  }

  static isOperationCancelled(controller) {
    return controller.signal.aborted || Selector.currentSelectOperation !== controller;
  }

  static async selectePayMethod(_this) {
    if (Selector.walletService && Selector.walletService.isFullCoverage()) return;
    if (Selector.loyaltyService && Selector.loyaltyService.isConfirmed() && Selector.loyaltyService.isFullCoverage()) return;

    if (Selector.fieldsService.getDisableState()) {
      return;
    }

    if (_this.getAttribute('data-wallet-currency-disabled') === 'true') {
      if (_this.type === 'radio') _this.checked = false;
      return;
    }

    // Cancel any ongoing selectePayMethod operation
    if (Selector.currentSelectOperation) {
      Selector.currentSelectOperation.abort();
    }

    // Create new AbortController for this operation
    const controller = new AbortController();
    Selector.currentSelectOperation = controller;

    let stcPay = false;
    let urPay = false;
    let applePay = false;
    let isApplePayWalletActive = false;
    // Read identity attributes from DOM (which element was clicked)
    const name = _this.attributes.name.value;
    const type = _this.attributes['data-type'].value;
    const code = _this.attributes[name].value;
    const id = _this.attributes['id'] ? _this.attributes['id'].value : '';
    const methodType = _this.attributes['data-method_type']?.value || '';
    const sub_option_value = _this.attributes['data-sub_option_value']?.value || '';

    // Look up all method data from mainConfigService
    const configData = Selector._lookupMethodData(code, type, methodType);
    const submitUrl = configData?.submit_url || '';
    const ccv_required = configData?.ccv_required || false;
    const fee = configData?.fee || '';
    const currencyCode = configData?.currency_code || '';
    const currencyCodedDefault = mainConfigService.get('currency_code') || '';
    const amount = configData?.amount || '';
    const description = configData?.description || '';
    const gateway = configData?.gateway || '';
    const cancel_url = configData?.cancel_url || '';
    const payment_url = configData?.payment_url || '';
    let canSaveCard = configData?.can_save_card || false;
    const direct_payment_url = configData?.direct_payment_url || '';
    const trandata = configData?.trandata || '';
    const redirectUrl = configData?.redirect_url || '';
    const card_pg = configData?.card_pg || '';
    const use_as_jazz_sdk = configData?.use_as_jazz_sdk || false;
    const brand = configData?.brand || '';
    const number = configData?.number || '';
    const expiry_month = configData?.expiry_month || '';
    const expiry_year = configData?.expiry_year || '';
    const bin = configData?.bin || '';

    // Look up billing from mainConfigService
    const walletBillingKey = card_pg || code;
    const billing = Selector._lookupBilling(walletBillingKey, type, methodType);

    // When wallet is active, use wallet_billing for display values
    const activeBilling = (Selector.walletService && Selector.walletService.isActive())
      ? (Selector.walletService.getWalletBilling(walletBillingKey) || billing)
      : billing;

    Selector.changeTotal(
      fee,
      currencyCode,
      currencyCodedDefault,
      amount,
      description,
      activeBilling
    );

    // Update wallet details display for the selected payment option
    if (Selector.walletService && Selector.walletService.isActive()) {
      Selector.walletService.updateWalletDetailsForMethod(walletBillingKey);
    }

    setMethod(
      name,
      code,
      submitUrl,
      cancel_url,
      redirectUrl,
      payment_url,
      id,
      ccv_required,
      canSaveCard,
      amount,
      currencyCode,
      gateway,
      card_pg,
      direct_payment_url,
      trandata,
      sub_option_value,
      brand,
      number,
      expiry_month,
      expiry_year,
      bin
    );

    const payBtn = this.documentCheckout.querySelector('#' + elements.payButton);
    if (payBtn) {
      payBtn.classList.remove('ottu__sdk-disabled-pay-button');
      payBtn.removeAttribute('disabled');
      payBtn.addEventListener('click', Selector.payButtonClick);
    }

    this.documentCheckout
      .querySelectorAll('.' + elements.paymentMethod)
      .forEach((element) => {
        element.classList.remove('ottu__sdk-border-green');
        element.classList.remove('ottu__sdk-onsite-method');
      });

    resetAllSavedCards(
      this.documentCheckout.querySelectorAll('.ottu__sdk-input-ccv')
    );

    resetSelectedCheckboxes(
      this.documentCheckout.querySelectorAll('.' + elements.accordionItemRadio),
      _this
    );

    this.documentCheckout
      .querySelectorAll('.ottu__sdk-radio-div')
      .forEach((element) => {
        if (element.querySelector('input').checked) {
          element.querySelector(`.${method.id}`)
            ? element.querySelector(`.${method.id}`).classList.add('d-flex')
            : '';
          // Show delete button for selected saved card
          const deleteBtn = element.querySelector(`.${elements.saveCardDeleteButton}`);
          if (deleteBtn) {
            deleteBtn.style.display = 'block';
          }
        } else {
          element.querySelector('.d-flex')
            ? element.querySelector('.d-flex').classList.remove('d-flex')
            : '';
          // Hide delete button for non-selected saved cards
          const deleteBtn = element.querySelector(`.${elements.saveCardDeleteButton}`);
          if (deleteBtn) {
            deleteBtn.style.display = 'none';
          }
        }
      });

    if ((name == SDK_FOPS.OTTU_PG && (!use_as_jazz_sdk || !checkFormsofPayments('jazz'))) || name == SDK_FOPS.STC_PAY || name == SDK_FOPS.UR_PAY) {
      canSaveCard = false;
    }

    const paymentType = mainConfigService.get('payment_type');
    const disableSaveCard =
      paymentType === PAYMENT_TYPES.AUTO_DEBIT ||
      (name === SDK_FOPS.OTTU_PG && paymentType === PAYMENT_TYPES.SAVE_CARD);

    this.documentCheckout.querySelector(
      `#${elements.cardSaveBlock}`
    ).innerHTML = getSaveCardCheckbox(canSaveCard, disableSaveCard);

    if (type === 'method') {
      _this.classList.toggle('ottu__sdk-border-green');
    }
    this.documentCheckout.querySelectorAll('.ottu__sdk-card-iframe-wrapper').forEach((el) => {
      el.classList.remove('show');
      el.classList.remove('ottu__sdk-selected-method-theme');
    });



    const key = _this.id?.replace('method', '');
    const iframeWrapper = this.documentCheckout.querySelector(`#iframe-container-${key} .ottu__sdk-card-iframe-wrapper`);
    if (iframeWrapper && methodType === 'payment_method') {
      iframeWrapper.classList.add('show');
      iframeWrapper.classList.add('ottu__sdk-selected-method-theme');
      _this.classList.add('ottu__sdk-onsite-mehod');
    }

    // --- CSUC (CyberSource Unified Checkout) - Handle BEFORE payment_services check ---
    if (name === 'csuc') {
      Selector.hideAllButtons(this.documentCheckout, elements);
      // Show wallet-buttons container for CSUC (it's a wallet-type payment method)
      Selector.documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
      try {
        const integration = Selector._getOrCreateCsucIntegration();
        await integration.initialize();
      } catch (error) {
        console.error('CSUC initialization error:', error);
        Selector._handleCsucError(error);
      }
      return;
    }

    if (!mainConfigService.get('payment_services')?.length) return;

    // Check if operation was cancelled
    if (Selector.isOperationCancelled(controller)) {
      return;
    }

    const showButtonBlock = (blockId) => {
      Selector.hideAllButtons(this.documentCheckout, elements);
      if (blockId === 'pay-button') {
        Selector.documentCheckout.querySelector('.wallet-buttons')?.classList.add('d-none');
      } else {
        Selector.documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
      }
      const block = this.documentCheckout.querySelector(`#${blockId}`);
      if (block) block.classList.remove('d-none');
      return block;
    };

    // Clean up CSUC containers when switching to non-CSUC payment method
    if (this.csucIntegration) {
      this.csucIntegration.destroy();
    }

    // Check for payment_services but don't return early - methods might be in payment_methods/flex_methods
    const hasPaymentServices = mainConfigService.get('payment_services')?.length > 0;

    // --- Google Pay ---
    if (hasPaymentServices && name === SDK_FOPS.GOOGLE_PAY && checkFormsofPayments('googlePay')) {
      const googlePayConfig =
        findPaymentConfig(
          mainConfigService.get('payment_services'),
          SDK_FOPS.GOOGLE_PAY,
          null,
          code
        );

      if (googlePayConfig) {
        googlePayConfigService.updateConfig(googlePayConfig);
        const googlePayInit = mainConfigService.get('googlePayInit');
        if (googlePayInit) {
          googlePayConfigService.updateConfig(googlePayInit);
        }
        if (Selector.walletService && Selector.walletService.isActive()) {
          Selector.walletService.syncPayConfigAmounts();
        }
      }

      if (Selector.walletService && Selector.walletService.isFullCoverage()) {
        showButtonBlock('pay-button');
      } else {
        const googleBtnBlock = showButtonBlock(elements.blockGoogleButton);
        if (googleBtnBlock) {
          // Check if operation was cancelled
          if (Selector.isOperationCancelled(controller)) {
            return;
          }

          if (!googlePayConfigService.get('googlePayLoaded')) {
            const googleBtnLoader = googleBtnBlock.querySelector(
              '.wallet-buttons-loader'
            );
            if (googleBtnLoader) {
              googleBtnLoader.style.display = 'block';
            }
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://pay.google.com/gp/p/js/pay.js';
            script.onload = async () => {
              const button = await onGooglePayLoaded(this.documentCheckout);
              // Check if still current operation
              if (Selector.isOperationCancelled(controller)) {
                return;
              }
              if (googleBtnLoader) {
                googleBtnLoader.style.display = 'none';
              }
              Selector.showGoogleButton(button);
              this.documentCheckout = Selector.documentCheckout;
              googlePayConfigService.updateConfig({ googlePayLoaded: true });
            };
            document.head.appendChild(script);
          } else {
            const button = await onGooglePayLoaded(this.documentCheckout);
            // Check if still current operation after async call
            if (!Selector.isOperationCancelled(controller)) {
              Selector.showGoogleButton(button);
            }
          }
        }
      }
    }

    // --- Apple Pay ---
    else if (hasPaymentServices && name === SDK_FOPS.APPLE_PAY && checkFormsofPayments('applePay')) {
      const applePayConfig =
        findPaymentConfig(
          mainConfigService.get('payment_services'),
          SDK_FOPS.APPLE_PAY,
          null,
          code
        );

      if (
        (_applePayAvailable() && applePayConfig)
      ) {
        applePay = true;
        applePayConfigService.updateConfig(applePayConfig);
        applePayConfigService.updateConfig(mainConfigService.get('applePayInit') || {});
        if (Selector.walletService && Selector.walletService.isActive()) {
          Selector.walletService.syncPayConfigAmounts();
        }

        if (mainConfigService.get('_studioEnabled')) {
          applePayConfigService.setSDKStudioConfigs(applePayConfig, mainConfigService.get('sdk_studio'));
        }

        if (Selector.walletService && Selector.walletService.isFullCoverage()) {
          showButtonBlock('pay-button');
        } else {
          handleApplePayStyles() && Selector.injectCSS(handleApplePayStyles());
          const appleBtnBlock = showButtonBlock(elements.blockAppleButton);
          const appleBtnLoader = appleBtnBlock.querySelector(
            '.wallet-buttons-loader'
          );
          if (appleBtnLoader) {
            appleBtnLoader.style.display = 'block';
          }
          if (appleBtnBlock) {
            isApplePayWalletActive = applePayConfigService.get('merchant_id')
              ? await _isWalletActive()
              : true;

            if (!Selector.isOperationCancelled(controller)) {
              if (appleBtnLoader) {
                appleBtnLoader.style.display = 'none';
              }
              Selector.showAppleButton(applePay, isApplePayWalletActive);
            }
          }
        }
      } else {
        Selector.hideAllButtons(this.documentCheckout, elements);
      }
    }

    // --- Samsung Pay ---
    else if(hasPaymentServices && name === SDK_FOPS.SAMSUNG_PAY && checkFormsofPayments('samsungPay')) {
      const samsungPayConfig =
        findPaymentConfig(
          mainConfigService.get('payment_services'),
          SDK_FOPS.SAMSUNG_PAY,
          null,
          code
        );

      if (samsungPayConfig) {
        samsungPayConfigService.updateConfig(samsungPayConfig);
        if (Selector.walletService && Selector.walletService.isActive()) {
          Selector.walletService.syncPayConfigAmounts();
        }
      }

      if (Selector.walletService && Selector.walletService.isFullCoverage()) {
        showButtonBlock('pay-button');
      } else {
        const samsungBtnBlock = showButtonBlock(elements.blockGoogleButton);
        if (samsungBtnBlock) {
          // Check if operation was cancelled
          if (Selector.isOperationCancelled(controller)) {
            return;
          }

          if (!samsungPayConfigService.get('samsungPayLoaded')) {
            const samsungBtnLoader = samsungBtnBlock.querySelector(
              '.wallet-buttons-loader'
            );
            if (samsungBtnLoader) {
              samsungBtnLoader.style.display = 'block';
            }
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://img.mpay.samsung.com/gsmpi/sdk/samsungpay_web_sdk.js'
            script.onload = async () => {
              const button = await loadSamsungPay();
              // Check if still current operation
              if (Selector.isOperationCancelled(controller)) {
                return;
              }
              if (samsungBtnLoader) {
                samsungBtnLoader.style.display = 'none';
              }
              Selector.showSamsungButton(button);
              this.documentCheckout = Selector.documentCheckout;
              samsungPayConfigService.updateConfig({ samsungPayLoaded: true });
            };
            document.head.appendChild(script);
          } else {
            const button = await loadSamsungPay();
            // Check if still current operation after async call
            if (!Selector.isOperationCancelled(controller)) {
              Selector.showSamsungButton(button);
            }
          }
        }
      }
    }

    // --- STC Pay ---
    else if (hasPaymentServices && name === SDK_FOPS.STC_PAY && checkFormsofPayments('stcPay')) {
      const stcPayConfig = findPaymentConfig(
        mainConfigService.get('payment_services'),
        SDK_FOPS.STC_PAY,
        null,
        code
      );
      if (stcPayConfig) {
        if (Selector.walletService && Selector.walletService.isFullCoverage()) {
          showButtonBlock('pay-button');
        } else {
          Selector.injectCSS(handleMobilePayStyles('stcPay'));
          const stcBtnBlock = showButtonBlock(elements.blockStcButton);

          if (stcBtnBlock) {
            stcPay = true;
            Selector.showStcButton(stcPayConfig);
          }
        }
      }
    }

    // --- UR Pay ---
    else if (hasPaymentServices &&name === SDK_FOPS.UR_PAY && checkFormsofPayments('urPay')) {
      const urPayConfig = findPaymentConfig(
        mainConfigService.get('payment_services'),
        SDK_FOPS.UR_PAY,
        null,
        code
      );
      if (urPayConfig) {
        if (Selector.walletService && Selector.walletService.isFullCoverage()) {
          showButtonBlock('pay-button');
        } else {
          Selector.injectCSS(handleMobilePayStyles('urPay'));
          const urPayBtnBlock = showButtonBlock(elements.blockUrpayButton);

          if (urPayBtnBlock) {
            urPay = true;
            Selector.showUrPayButton(urPayConfig);
          }
        }
      }
    }

    // --- Friend Pay ---
    else if (name === SDK_FOPS.FRIEND_PAY) {
      console.log('Friend Pay selected:', code);
      // Future implementation: Show pending payment screen
      // For now, just allow selection
    }

    // --- Default Pay Button ---
    else {
      const payBtnBlock = showButtonBlock('pay-button');
      if (payBtnBlock) payBtnBlock.classList.remove('d-none');
    }

    // --- Event Listener Binding ---
    const payButtonService = new PayButtonEventListenerService(
      this.documentCheckout,
      elements,
      this.callbackService,
      Selector,
    );
    payButtonService.init(applePay, isApplePayWalletActive, stcPay, urPay);
  }

  static hideAllButtons(documentCheckout, elements) {
    const payBtnBlock = documentCheckout.querySelector(`#pay-button`);
    if (payBtnBlock) payBtnBlock.classList.add('d-none');

    const googleBtnBlock = documentCheckout.querySelector(
      `#${elements.blockGoogleButton}`
    );
    if (googleBtnBlock) googleBtnBlock.classList.add('d-none');

    const stcBtnBlock = documentCheckout.querySelector(
      `#${elements.blockStcButton}`
    );
    if (stcBtnBlock) stcBtnBlock.classList.add('d-none');

    const urPayBtnBlock = documentCheckout.querySelector(
      `#${elements.blockUrpayButton}`
    );
    if (urPayBtnBlock) urPayBtnBlock.classList.add('d-none');

    const appleBtnBlock = documentCheckout.querySelector(
      `#${elements.blockAppleButton}`
    );
    if (appleBtnBlock) appleBtnBlock.classList.add('d-none');
  }

  /**
   * Parses CSS text into individual rule texts using a constructed stylesheet,
   * so the browser does the parsing rather than a hand-rolled rule splitter.
   * Returns null when constructed stylesheets are unavailable (Safari < 16.4,
   * jsdom) or the text yields no rules, which tells the caller to fall back to
   * inline CSS text.
   * @param {string} cssText
   * @returns {string[]|null}
   */
  static _parseCssRules = (cssText) => {
    if (
      typeof CSSStyleSheet !== 'function' ||
      typeof CSSStyleSheet.prototype.replaceSync !== 'function'
    ) {
      return null;
    }

    try {
      const parsed = new CSSStyleSheet();
      parsed.replaceSync(cssText);
      const rules = Array.from(parsed.cssRules, (rule) => rule.cssText);
      return rules.length ? rules : null;
    } catch (error) {
      return null;
    }
  };

  /**
   * Adds already-parsed rules to a style element through its CSSOM sheet.
   * @param {HTMLStyleElement} styleElement - must already be in the document
   * @param {string[]} rules
   * @returns {boolean} whether every rule was inserted
   */
  static _insertCssRules = (styleElement, rules) => {
    const sheet = styleElement.sheet;
    if (!sheet) {
      return false;
    }

    try {
      rules.forEach((rule) => sheet.insertRule(rule, sheet.cssRules.length));
      return true;
    } catch (error) {
      return false;
    }
  };

  static injectCSS = (css) => {
    if (!css.innerHTML) {
      return;
    }

    let sdk_child = Selector.documentCheckout.querySelector('#' + elements.sdkChild);
    const cssText = css.innerHTML;
    css.type = 'text/css';

    // A <style> element that carries its CSS as inline text is subject to
    // style-src-elem. The checkout page reports that, because the policy's
    // hash list cancels the 'unsafe-inline' sitting beside it. Adding the same
    // rules through the CSSOM is exempt from CSP, and keeping the element in
    // place leaves cascade order exactly as it was.
    const rules = Selector._parseCssRules(cssText);

    css.textContent = rules ? '' : cssText;
    sdk_child.appendChild(css);

    // The sheet only exists once the element is in the document, so insertion
    // happens after appending. If anything about it fails, put the CSS back as
    // inline text: a reported violation is strictly better than losing styles.
    if (rules && !Selector._insertCssRules(css, rules)) {
      css.textContent = cssText;
    }

    return css;
  };

  static _onsitePay() {
    // Check if Jazz SDK should be used for this payment method
    const hasJazzSDKEnabled = mainConfigService.get('payment_methods')?.find(
      (pm) => pm.code === method.code
    );
    if (hasJazzSDKEnabled && hasJazzSDKEnabled.use_as_jazz_sdk && checkFormsofPayments('jazz')) {
      const iframeIds = Selector.jazzIntegration.getAllIframeIds();

      // Find the iframe that matches the current method
      const iframeManager = iframeIds.find(iframeId => {
        const manager = Selector.jazzIntegration.getIframeManager(iframeId);
        return manager && manager.containerId === `payment-${method.id}${elements.cardIframe}`;
      });

      if (iframeManager) {
        Selector.jazzIntegration.validateCardFields(iframeManager);
      }
    } else {
      Selector._ottuPGPay();
    }
  }

  static _redirectPay() {
    if (checkFormsofPayments('redirect')) {
      Selector.fieldsService.disableEnableFields(true);

      const cardSave = this.documentCheckout.querySelector(
        '#' + elements.cardSaveCheckbox
      )
        ? this.documentCheckout.querySelector('#' + elements.cardSaveCheckbox)
          .checked
        : false;
      const submit_url = window.redirectSubmitUrl
        ? window.redirectSubmitUrl
        : method.submit_url;

      redirectPayFetch(submit_url, mainConfigService.get('apiKey'), method.code, cardSave)
        .then((response) => {
          Selector.successResponse(response, SDK_FOPS.REDIRECT);
        })
        .catch((err) => {
          Selector.fieldsService.disableEnableFields(false);
          if (err.status >= 500) {
            err = {
              status: 'error',
              message:
                'Oops, something went wrong. Refresh the page and try again.',
            };
            Selector.callbackService.callBackError(err);
          } else {
            Selector.errorResponse(err);
          }
        });
    }
  }

  static async _walletSubmitPay() {
    Selector.fieldsService.disableEnableFields(true);

    try {
      await Selector.callbackService.callBackPayment();

      const submitUrl = Selector.walletService.getSubmitUrl();
      const apiKey = mainConfigService.get('apiKey');
      const code = Selector.walletService.getActiveCode();
      const sessionId = mainConfigService.get('session_id');

      const response = await walletSubmitFetch(submitUrl, apiKey, code, sessionId);
      Selector.successResponse(response, SDK_FOPS.WALLET);
    } catch (err) {
      Selector.fieldsService.disableEnableFields(false);
      if (err.status >= 500) {
        err = {
          status: 'error',
          message:
            'Oops, something went wrong. Refresh the page and try again.',
        };
        Selector.callbackService.callBackError(err);
      } else {
        Selector.errorResponse(err);
      }
    }
  }

  static async _payAbaWay() {
    Selector.fieldsService.disableEnableFields(true);
    try {
      
      await Selector.callbackService.callBackPayment();

      if (!this.abaIntegration) {
        this.abaIntegration = new AbaPaywayIntegration(
          method.submit_url,
          method.payment_method,
          Selector.curScriptElement,
          Selector.fieldsService,
        );
      }

      await this.abaIntegration.initialize();
    } catch (error) {
      Selector.fieldsService.disableEnableFields(false);
      Selector.showModal(
        getFailedModalHtml(
          error.message || 'Something Went Wrong.',
          $t('Error')
        ),
        null,
        'info'
      );
    }
  }

  static async _payDoku() {
    Selector.fieldsService.disableEnableFields(true);
    try {
      await Selector.callbackService.callBackPayment();

      if (!this.dokuIntegration) {
        this.dokuIntegration = new DokuIntegration(
          method.submit_url,
          method.payment_method,
          Selector.curScriptElement,
          Selector.fieldsService,
        );
      }

      await this.dokuIntegration.initialize();
    } catch (error) {
      Selector.fieldsService.disableEnableFields(false);
      Selector.showModal(
        getFailedModalHtml(
          error.message || 'Something Went Wrong.',
          $t('Error')
        ),
        null,
        'info'
      );
    }
  }

  static async _payGeidea() {
    Selector.fieldsService.disableEnableFields(true);
    try {
      await Selector.callbackService.callBackPayment();

      if (!this.geideaIntegration) {
        this.geideaIntegration = new GeideaIntegration(
          method.submit_url,
          method.payment_method,
          Selector.curScriptElement,
          Selector.fieldsService,
        );
      }

      await this.geideaIntegration.initialize();
    } catch (error) {
      Selector.fieldsService.disableEnableFields(false);
      Selector.showModal(
        getFailedModalHtml(
          error.message || 'Something Went Wrong.',
          $t('Error')
        ),
        null,
        'info'
      );
    }
  }

  static _getOrCreateCsucIntegration() {
    if (!this.csucIntegration) {
      this.csucIntegration = new CsucIntegration(
        method.submit_url,
        method.payment_method,
        Selector.curScriptElement,
        Selector.fieldsService,
        Selector.documentCheckout
      );
    } else {
      // Update submit URL when switching between different CSUC methods
      this.csucIntegration.updateSubmitUrl(method.submit_url);
    }
    return this.csucIntegration;
  }

  static _handleCsucError(error) {
    console.error('CSUC payment error:', error);
    Selector.fieldsService.disableEnableFields(false);
    Selector.showModal(
      getFailedModalHtml(
        error.message || 'Something Went Wrong.',
        $t('Error')
      ),
      null,
      'info'
    );
  }

  static async _payCsuc() {
    Selector.fieldsService.disableEnableFields(true);

    try {
      await Selector.callbackService.callBackPayment();
      const integration = this._getOrCreateCsucIntegration();
      await integration.initialize();
    } catch (error) {
      this._handleCsucError(error);
    }
  }

  static _mobilePay(type) {
    Selector.fieldsService.disableEnableFields(true, type);
    mainConfigService.updateConfig({
      customer_phone: mainConfigService
        .get('customer_phone')
        .replace(/[^0-9]+/g, ''),
    }); 
    Selector.showMobilePaymentModal(
      getMobilePayModal(
        mainConfigService.get('customer_phone'),
        method.can_save_card,
        false,
        type
      ),
      'otp',
      false,
      type
    );
  }

  static showCancelModal(html) {
    const modal = Selector.documentCheckout.querySelector(
      '#' + elements.modal
    );
    const modalOverlay = Selector.documentCheckout.querySelector(
      '#' + elements.modalOverlay
    );
    modal.innerHTML = html;
    modal.classList.remove('d-none');
    modal.classList.add('ottu__sdk-active');
    modalOverlay.classList.add('ottu__sdk-active');

    const yesBtn = modal.querySelector('#' + elements.modalYesBtn);
    const noBtn = modal.querySelector('#' + elements.modalNoBtn);

    yesBtn.addEventListener('click', () => {
      Selector._cancelPay();
      Selector.hideModal();
    })

    noBtn.addEventListener('click', () => {
      Selector.hideModal();
    })
  }

  static async _cancelPay() {
    Selector.fieldsService.disableEnableFields(true, 'cancel');
    cancelPayFetch(mainConfigService.get('cancel_url'), mainConfigService.get('apiKey'))
      .then((response) => {
        Selector.fieldsService.disableEnableFields(false);
        Selector.callbackService.callBackCancel(response);
      })
      .catch((err) => {
        Selector.fieldsService.disableEnableFields(false, 'cancel');
        if (err.status >= 500) {
          err = {
            status: 'error',
            message:
              'Oops, something went wrong. Refresh the page and try again.',
          };
          Selector.callbackService.callBackError(err);
        } else {
          Selector.errorResponse(err);
        }
      });
  }

  static async _ottuPGPay() {
    Selector.fieldsService.disableEnableFields(true);
    let redirectUrl = method.redirect_url;
    if (mainConfigService.get('lang') === 'ar') {
      redirectUrl += `?setLang=${mainConfigService.get('lang')}`;
    }
  
    try {
      await Selector.callbackService.callBackPayment({ redirect_url: redirectUrl || '' });
    } catch (error) {
      Selector.fieldsService.disableEnableFields(false);
      Selector.errorResponse(error);
    }
  }

  static async _handleCVVTokenPayment(method) {
    // Selector.disableEnableFileds(true);
    let isOttuPg;
    const matchedMethod = mainConfigService.get('payment_methods')?.find(
      (pm) => pm.code === method.card_pg
    );
    isOttuPg = matchedMethod.flow === SDK_FOPS.OTTU_PG ? true : false;
    if (matchedMethod && isOttuPg) {
      if(!matchedMethod.trandata){
        Selector.showModal(
          getFailedModalHtml(
            'Oops, something went wrong. Refresh the page and try again.',
            $t('Error'),
          ),
          null,
          'info'
        );
        Selector.fieldsService.disableEnableFileds(false);
        return;
      }
      method.trandata = matchedMethod.trandata;
      method.encKeyUrl = matchedMethod.enc_key_url;
    }
      // Find the CVV iframe for this token
      const iframeIds = Selector.jazzIntegration.getAllIframeIds();

      // Find the iframe that matches the current token
      const iframeId = iframeIds.find(iframeId => {
        const manager = Selector.jazzIntegration.getIframeManager(iframeId);
        return manager && manager.containerId === `${method.id}${elements.cvvIframe}`;
      });

      if (iframeId) {
        Selector.jazzIntegration.validateCvvField(iframeId);
    }
    return;
  }

  static async _handleTokenPayment(method) {
    // Disable the UI before starting the payment process
    Selector.fieldsService.disableEnableFields(true);

    try {
      // Await the promise from the now-decoupled payment flow
      const response = await Selector.tokenPaymentFlow.processPayment(method);

      // Handle the success case by updating the UI
      Selector.successResponse(response, 'token');

    } catch (error) {
      // Handle the failure case by inspecting the error and updating the UI
      if (error.type === 'validation') {
        // Show validation error on the specific field
        const element = Selector.documentCheckout.querySelector(`.${error.method.id}`);
        if (element) {
          element.classList.add('ottu__sdk-invalid-input');
          element.querySelector('i').innerHTML = error.message;
        }
        return;
      }
      if (!error.status) {
        // Show a generic error modal
        Selector.showModal(
          getFailedModalHtml(error.message || 'Something went wrong. Please try again.', $t('Error')),
          null,
          'info'
        );
      } else {
        // Show a specific API error response
        Selector.errorResponse(error);
      }
    } finally {
      // ALWAYS re-enable the UI, regardless of success or failure
      Selector.fieldsService.disableEnableFields(false);
    }
  }

  static successResponse(response, type, mobilePay) {
    if (mobilePay) {
      var modal = Selector.documentCheckout.querySelector(
        '#' + elements.mobilePayModal
      );
      var otpBlock = modal.querySelector('#' + elements.mobilePayOTPBlock);
      Selector.fieldsService.disableEnableFields(false, mobilePay);
    } else {
      Selector.fieldsService.disableEnableFields(false);
    }
    if (checkResponseStatus3ds(response)) {
      const method = response.method?.toLowerCase();
      if (method === THREEDS_METHODS.REDIRECT) {
        Selector.callbackService.callBackPayment(response);
      } else if(method === THREEDS_METHODS.IFRAME) {
        Selector.generate3DSPopUp(response);
      } else {
        console.warn(`3DS method is invalid: ${response.method}`);
      }
    } else if (checkResponseStatusSuccess(response)) {
      if (type === SDK_FOPS.REDIRECT) {
        Selector.callbackService.callBackPayment({ redirect_url: response.redirect_url || '' });
      } else {
        if (mobilePay) {
          Selector.hideModal(mobilePay);
        }
        Selector.callbackService.callBackSuccess(response);
      }
    } else if (
      checkResponseStatusCanceled(response) ||
      checkResponseStatusFailed(response)
    ) {
      if (mobilePay) {
        Selector.showErrorMessage(modal, response, otpBlock, mobilePay);
      }
      Selector.callbackService.callBackCancel(response);
    } else if (checkResponseStatusError(response)) {
      if (mobilePay) {
        Selector.showErrorMessage(modal, response, otpBlock, mobilePay);
      }
      Selector.callbackService.callBackError(response);
    } else {
      Selector.callbackService.callBackError({
        status: 'error',
        message: 'incorrect response',
      });
    }
  }

  static async getinstallmentsOptions(validationUrl, code) {
    try {
      return await fetchInstallmentOptions(validationUrl, mainConfigService.get('apiKey'), code)
    } catch (error) {
      Selector.errorResponse(error);
      return null;
    }
  }

  static showHide3ds(show) {
    const sdk = this.documentCheckout.querySelector('#' + elements.sdkChild);
    const threeDS = this.documentCheckout.querySelector('#' + elements.threeDS);
    if (show) {
      sdk.classList.add('d-none');
      threeDS.classList.remove('d-none');
    } else {
      threeDS.innerHTML = '';
      threeDS.classList.add('d-none');
      sdk.classList.remove('d-none');
    }
  }

  static generate3DSPopUp(response) {
    Selector.threeDSService.generate3DSPopUp(response).catch((error) => {
      console.error('3DS popup generation failed:', error);
    });
  }

  static errorResponse(err) {
    if (typeof err === 'object' && typeof err.then === 'function') {
      err.then((error) => {
        if (error.detail) {
          let buttonText = error.operation === 'cancel' ? 'OK' : null
          Selector.showModal(
            getFailedModalHtml(
              error.detail || 'Something Went Wrong.',
              $t('Error'),
              buttonText
            ),
            null,
            'info'
          );
        } else if (
          Object.keys(error).length &&
          Array.isArray(error[Object.keys(error)[0]])
        ) {
          let htmlContent = '';
          for (let key in error) {
            error[key].forEach((value) => {
              htmlContent += '<p>' + value + '</p>';
            });
          }
          Selector.showModal(
            getFailedModalHtml(htmlContent || 'Something Went Wrong.', $t('Error')),
            null,
            'info'
          );
        } else {
          Selector.showModal(
            getFailedModalHtml(error.message  || 'Something Went Wrong.', $t('Error')),
            null,
            'info'
          );
          console.log(error);
        }
      });
    } else {
      console.log(err)
      // Integrations that hand over a payment result as a plain object — Jazz
      // onsite card — carry the fields the merchant needs to tell which
      // payment failed: form_of_payment, payment_gateway_info, redirect_url,
      // session_id, reference_number. Rebuilding the payload from scratch
      // dropped every one of them, leaving merchants with nothing to branch
      // on (#159858).
      //
      // The gateway fields are spread underneath `status` and `message` so
      // no payload field can override those two. `message` is non-enumerable
      // on Error and Response, which the spread would drop, so it is carried
      // across explicitly.
      //
      // It carries the reason as given — Connect's popup renders it straight
      // to the payer, so wrapping it in an SDK-authored sentence put copy on
      // screen that described the transport rather than the decline.
      Selector.callbackService.callBackError({
        ...(err && typeof err === 'object' ? err : {}),
        status: 'error',
        message: err.message,
      });
    }
  }

  static _checkPayButtonExists () {
    const payButton = Selector.documentCheckout.querySelector('#' + elements.payButton);
    return payButton;
  }

  static _changeOnsiteIframeHeight () {
    const payButton = Selector.documentCheckout.querySelector('#' + elements.accordionIframe);
    return payButton;
  }

  static showModal(html, response, type) {
    let modal;
    if (type == 'info') {
      modal = Selector.documentCheckout.querySelector(
        '#' + elements.popupModal
      );
    } else {
      modal = Selector.documentCheckout.querySelector('#' + elements.modal);
    }
    const modalOverlay = Selector.documentCheckout.querySelector(
      '#' + elements.modalOverlay
    );
    modal.innerHTML = html;
    modal.classList.remove('d-none');
    modal.classList.add('ottu__sdk-active');
    modalOverlay.classList.add('ottu__sdk-active');
    modal.querySelectorAll('.close-button').forEach((closeBtns) => {
      closeBtns.addEventListener(
        'click',
        function () {
          if (response && response.status == 'canceled') {
            Selector.callbackService.callBackCancel(response);
          } else if (response && response.status == 'error') {
            Selector.callbackService.callBackError(response);
          }
          if (type === 'info') {
            Selector.hideModal(type);
          } else {
            Selector.hideModal();
          }
        },
        true
      );
    });
  }

  static handleOtpResend(modal, otpBlock, saveCard, type) {
    let resendOtpBtn = modal.querySelector(
      '#' + elements.mobilePayResendOtpBtn
    );
    let payBtn = modal.querySelector('#' + elements.mobilePayOtpSubmitBtn);
    let startTime = mainConfigService.get('mobilePayOtpCooldownTime');
    let timer;

    if (resendOtpBtn) {
      timer = setInterval(() => {
        resendOtpBtn.querySelector('span').innerHTML =
          $t('Resend OTP') + '(' + --startTime + $t('Sec') + ')';
      }, 1000);
      setTimeout(function () {
        clearInterval(timer);
        resendOtpBtn.querySelector('span').innerHTML = $t('Resend OTP');
        resendOtpBtn.classList.remove('ottu__sdk-disabled');
        resendOtpBtn.disabled = false;

        resendOtpBtn.addEventListener('click', () => {
          resendOtpBtn.classList.add('loading');
          payBtn.disabled = true;
          Selector.fieldsService.disableEnableFields(true, type);
          sendMobilePayOtp(
            method.submit_url,
            mainConfigService.get('apiKey'),
            mainConfigService.get('session_id'),
            method.code,
            mainConfigService.get('customer_phone'),
            saveCard
          )
            .then(() => {
              resendOtpBtn.classList.remove('loading');
              payBtn.disabled = false;
              Selector.fieldsService.disableEnableFields(false);
              Selector.showMobilePaymentModal(
                getMobilePayOTPModal(),
                'pay',
                saveCard,
                type
              );
            })
            .catch((err) => {
              resendOtpBtn.classList.remove('loading');
              Selector.showErrorMessage(modal, err, otpBlock, type);
            });
        });
      }, startTime * 1000);
    }
  }

  static closeMobileModal(type) {
    Selector.hideModal(type);
    Selector.unselectMethod();
    Selector.fieldsService.disableEnableFields(false, type);
  }

  static handleMobileModalEscKey(type, action) {
    if (event.key === 'Escape' && !Selector.disableFileds) {
      Selector.closeMobileModal(type, action);
    } else {
      Selector.addEscKeyListeners(Selector.escKeyListener);
    }
  }

  static removeEscKeyListeners(handleEscKey) {
    document.removeEventListener('keydown', handleEscKey);
  }

  static addEscKeyListeners(handleEscKey) {
    document.addEventListener('keydown', handleEscKey, { once: true });
  }

  static showMobilePaymentModal(html, action, saveCardValue, type) {
    let saveCard = saveCardValue;
    const modal = Selector.documentCheckout.querySelector(
      '#' + elements.mobilePayModal
    );
    const modalOverlay = Selector.documentCheckout.querySelector(
      '#' + elements.modalOverlay
    );
    modal.innerHTML = html;
    modal.classList.remove('d-none');
    modal.classList.add('ottu__sdk-active');
    modalOverlay.classList.add('ottu__sdk-active');
    Selector.fieldsService.disableEnableFields(false);
    Selector.escKeyListener = Selector.handleMobileModalEscKey.bind(
      null,
      type,
      action
    );

    const closeButton = modal.querySelector('.close-button');
    closeButton.addEventListener('click', () => {
      Selector.removeEscKeyListeners(Selector.escKeyListener);
      Selector.closeMobileModal(type);
    });

    if (action == 'otp') {
      let mobileNoBlock = modal.querySelector(
        '#' + elements.mobilePayPhoneNumberBlock
      );
      let sendBtn = modal.querySelector('#' + elements.mobilePaySubmitBtn);
      Selector.addEscKeyListeners(Selector.escKeyListener);

      mobileNoBlock
        .querySelector('input')
        .addEventListener('input', (e) => {
          mobileNoBlock.classList.remove('ottu__sdk-invalid-input');
          modal.querySelector('i').innerHTML = '';
          e.target.value = e.target.value.replace(/[^0-9]+/g, '').slice(0, 12);
          e.target.value = phoneNumberSetSpace(e.target.value);
        });

      if (sendBtn) {
        sendBtn.addEventListener(
          'click',
          () => {
            Selector.callbackService.callBackPayment()
              .then(() => {
                mainConfigService.updateConfig({
                  customer_phone: modal
                    .querySelector('#' + elements.mobilePayPhoneNumber)
                    .value.replace(/ /g, ''),
                });
                saveCard = modal.querySelector('#' + elements.mobilePaySaveCard)
                  ? modal.querySelector('#' + elements.mobilePaySaveCard)
                    .checked
                  : false;
                const valid = validateMobilePayFields(
                  mainConfigService.get('customer_phone'),
                  'phoneNo'
                );
                if (valid) {
                  Selector.fieldsService.disableEnableFields(true, type);
                  sendMobilePayOtp(
                    method.submit_url,
                    mainConfigService.get('apiKey'),
                    mainConfigService.get('session_id'),
                    method.code,
                    mainConfigService.get('customer_phone'),
                    saveCard
                  )
                    .then(() => {
                      Selector.fieldsService.disableEnableFields(false);
                      Selector.showMobilePaymentModal(
                        getMobilePayOTPModal(),
                        'pay',
                        saveCard,
                        type
                      );
                    })
                    .catch((err) => {
                      Selector.showErrorMessage(
                        modal,
                        err,
                        mobileNoBlock,
                        type
                      );
                    });
                } else {
                  const errMessage = {
                    message: 'Please enter a valid mobile number',
                  };
                  Selector.showErrorMessage(
                    modal,
                    errMessage,
                    mobileNoBlock,
                    type
                  );
                }
              })
              .catch(() => {
                Selector.closeMobileModal(type);
              });
          },
          true
        );
      }
    } else if (action == 'pay') {
      let otpBlock = modal.querySelector('#' + elements.mobilePayOTPBlock);
      let payBtn = modal.querySelector('#' + elements.mobilePayOtpSubmitBtn);

      Selector.addEscKeyListeners(Selector.escKeyListener);
      Selector.handleOtpResend(modal, otpBlock, saveCardValue, type);

      otpBlock.querySelector('input').addEventListener('input', function (e) {
        otpBlock.classList.remove('ottu__sdk-invalid-input');
        e.target.value = e.target.value.replace(/[^0-9]+/g, '');
      });

      modal
        .querySelector('.ottu__sdk-back-button')
        .addEventListener('click', () => {
          Selector.removeEscKeyListeners(Selector.escKeyListener);
          Selector.showMobilePaymentModal(
            getMobilePayModal(
              mainConfigService.get('customer_phone'),
              method.can_save_card,
              saveCard
            ),
            'otp',
            saveCard,
            type
          );
        });

      if (payBtn) {
        payBtn.addEventListener(
          'click',
          () => {
            let otpValue = modal
              .querySelector('#' + elements.mobilePayOTP)
              .value.replace(/ /g, '');
            if (otpValue) {
              payBtn.classList.add('loading');
              Selector.fieldsService.disableEnableFields(true, type);
              submitMobilePayOTP(
                method.payment_url,
                mainConfigService.get('apiKey'),
                mainConfigService.get('session_id'),
                otpValue
              )
                .then((response) => {
                  payBtn.classList.remove('loading');
                  Selector.successResponse(response, '', type);
                })
                .catch((err) => {
                  payBtn.classList.remove('loading');
                  Selector.showErrorMessage(modal, err, otpBlock, type);
                });
            } else {
              Selector.showErrorMessage(
                modal,
                { message: 'Please enter OTP' },
                otpBlock,
                type
              );
            }
          },
          true
        );
      }
    }
  }

  static hideModal(type) {
    let modal;
    if (type === 'stcPay' || type === 'urPay') {
      modal = Selector.documentCheckout.querySelector(
        '#' + elements.mobilePayModal
      );
    } else if (type === 'info') {
      modal = Selector.documentCheckout.querySelector(
        '#' + elements.popupModal
      );
    } else {
      modal = Selector.documentCheckout.querySelector('#' + elements.modal);
    }
    const modalOverlay = Selector.documentCheckout.querySelector(
      '#' + elements.modalOverlay
    );
    modal.classList.remove('ottu__sdk-active');
    modal.classList.remove('d-none');
    modalOverlay.classList.remove('ottu__sdk-active');
    modal.innerHTML = '';
  }

  static showPaymentProcessingLoader() {
    const overlay = Selector.documentCheckout.querySelector(`#${elements.modalOverlay}`);
    if (!overlay) return;

    overlay.classList.add('ottu__sdk-active');

    let loader = overlay.querySelector('.ottu__sdk-samsung-pay-processing-loader');
    if (!loader) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = paymentProcessingLoader();
      loader = tempDiv.firstElementChild;
      overlay.appendChild(loader);
    }

    loader.classList.add('ottu__sdk-active');
  }

  static hidePaymentProcessingLoader() {
    const overlay = Selector.documentCheckout.querySelector(`#${elements.modalOverlay}`);
    if (!overlay) return;

    overlay.classList.remove('ottu__sdk-active');

    const loader = overlay.querySelector('.ottu__sdk-samsung-pay-processing-loader');
    if (loader) {
      loader.classList.remove('ottu__sdk-active');
    }
  }

  static showFriendPaySheet() {
    const sheetHtml = friendPaySheetModal();

    this.friendPayService.showMainSheet(sheetHtml, {
      onClose: () => Selector.closeFriendPaySheet(),
      onSendToFriend: () => {
        Selector.closeFriendPaySheet();
        Selector.showFriendPaySendSheet();
      },
      onChangePayment: () => Selector.closeFriendPaySheet(),
      onUpdate: async () => await Selector.handleFriendPayUpdate()
    });
  }

  static closeFriendPaySheet() {
    this.friendPayService.closeSheet(FRIEND_PAY_SELECTORS.MAIN_SHEET);
  }

  static showFriendPayStatusModal(type, heading, subtitle) {
    let iconSvg;

    if (type === 'success') {
      iconSvg = logoSvg.friendPaySuccess;
    } else {
      iconSvg = logoSvg.friendPayFailed;
    }

    const modalHtml = friendPayStatusModal(iconSvg, heading, subtitle);
    Selector.showModal(modalHtml, null, 'info');
  }

  static showFriendPayStatusLoadingModal() {
    const modalHtml = friendPayStatusLoadingModal();
    Selector.showModal(modalHtml, null, 'info');
  }

  static async handleFriendPayUpdate() {
    // Show loading modal immediately
    Selector.showFriendPayStatusLoadingModal();

    try {
      // Get configuration parameters
      const merchant_id = mainConfigService.get('merchant_id');
      const session_id = mainConfigService.get('session_id');
      const apiKey = mainConfigService.get('apiKey');

      // Validate required parameters
      if (!merchant_id || !session_id || !apiKey) {
        Selector.showFriendPayStatusModal(
          'failed',
          $t('Unable to check payment status'),
          $t('Please try again later or contact support')
        );
        return;
      }

      // Call API to get checkout page status
      const response = await getCheckoutPageStatus(merchant_id, session_id, apiKey);

      // Check is_paid flag
      if (response && response.is_paid === true) {
        // Payment completed - show success message
        Selector.showFriendPayStatusModal(
          'success',
          $t('Payment completed'),
          $t('Your friend has paid for your order. Thank you!')
        );

        // Close the friend pay sheet after brief delay
        setTimeout(() => {
          Selector.closeFriendPaySheet();
        }, 1500);
      } else {
        // Payment not completed yet
        Selector.showFriendPayStatusModal(
          'failed',
          $t('Payment pending'),
          $t('Your friend has not paid yet')
        );
      }
    } catch (error) {
      // Handle API errors gracefully
      Selector.showFriendPayStatusModal(
        'failed',
        $t('Unable to check payment status'),
        $t('Please try again later or contact support')
      );
    }
  }

  static showFriendPaySendSheet() {
    const sendSheetHtml = friendPaySendSheet();

    this.friendPayService.showSendSheet(sendSheetHtml, {
      onClose: () => {
        Selector.closeFriendPaySendSheet();
        Selector.closeFriendPaySheet();
      }
    });
  }

  static closeFriendPaySendSheet() {
    this.friendPayService.closeSheet(FRIEND_PAY_SELECTORS.SEND_SHEET);
  }

  static pay({ token }) {
    setMethod('token', token, process.env.SUBMIT_URL);
    Selector._handleTokenPayment(method);
  }

  static _deleteToken(url, radioDiv) {
    Selector.fieldsService.disableEnableFields(true, 'token');
    deleteTokenFetch(url, mainConfigService.get('apiKey'))
      .then(() => {
        Selector.hideModal();
        Selector.unselectMethod();
        radioDiv.remove();
        let savedCards = this.documentCheckout.querySelectorAll(
          '.ottu__sdk-radio-div'
        );
        if (!savedCards.length) {
          this.documentCheckout
            .querySelector('#' + elements.savedCards)
            .classList.add('d-none');
        }
        Selector.fieldsService.disableEnableFields(false);
      })
      .catch((err) => {
        Selector.fieldsService.disableEnableFields(false);
        Selector.hideModal();
        Selector.errorResponse(err);
      });
  }

  static showAppleButton(applePay, isWalletActive) {
    if (applePay) {
      let block = this.documentCheckout.querySelector(
        `#${elements.blockAppleButton}`
      );
      block.classList.remove('d-none');
      block.innerHTML = getApplePayHtml(applePay, isWalletActive);
    }
  }

  static showGoogleButton(button) {
    if (button) {
      button.classList.add('google-pay-animation');
      let block = this.documentCheckout.querySelector(
        `#${elements.blockGoogleButton}`
      );
      block.classList.remove('d-none');
      block.innerHTML = '';
      block.appendChild(button);
    }
  }

  static showStcButton(stcPay) {
    let block = this.documentCheckout.querySelector(
      `#${elements.blockStcButton}`
    );
    block.innerHTML = getWalletButtonsHtml(stcPay);
    block.classList.remove('d-none');
  }

  static showUrPayButton(urPay) {
    let block = this.documentCheckout.querySelector(
      `#${elements.blockUrpayButton}`
    );
    block.innerHTML = getWalletButtonsHtml(urPay);
    block.classList.remove('d-none');
  }

  static showErrorMessage(modal, err, element, type) {
    Selector.addEscKeyListeners(Selector.escKeyListener);
    element.classList.add('ottu__sdk-invalid-input');
    Selector.fieldsService.disableEnableFields(false, type);

    const setMessage = (msg) => {
      modal.querySelector('i').innerHTML = escapeHtml(msg || 'Something Went Wrong');
    };

    if (err.status >= 500) {
      setMessage('Something Went Wrong');
    } else if (typeof err === 'object' && typeof err.then === 'function') {
      err.then((error) => {
        if (error.message) {
          setMessage(error.message);
        }
      });
    } else if (err.message) {
      setMessage($t(err.message));
    }
  }

  static unselectMethod() {
    method.type = '';
    this.documentCheckout.querySelector(`#${elements.feesBlock}`).innerHTML =
      '';
    this.documentCheckout.querySelector(
      `#${elements.cardSaveBlock}`
    ).innerHTML = getSaveCardCheckbox(false);
  }

  static translateHeaders(lang) {
    this.documentCheckout.querySelector("#ottu-js-sdk").setAttribute("class", lang || 'en');
    this.documentCheckout.querySelector(".ottu__sdk-header").innerHTML = $t('Payment Details');
    this.documentCheckout.querySelector(".ottu__sdk-header2").innerHTML = $t('Pay With');
  }
  
  static showSamsungButton(button) {
    if (button) {
      button.classList.add("ottu__sdk-black-div")
      let block = this.documentCheckout.querySelector(
        `#${elements.blockSamsungButton}`
      );
      block.classList.remove('d-none');
      block.innerHTML = '';
      block.appendChild(button);
    }
  }

  static async embedCVVIframe(cards) {
    if (!Selector.jazzIntegration) {
      Selector.jazzIntegration = new JazzIntegration({
        selector: Selector,
        callBackService: Selector.callbackService,
        fieldsService: Selector.fieldsService,
        sessionId: mainConfigService.get('session_id'),
        merchantId: mainConfigService.get('merchant_id'),
        apiKey: mainConfigService.get('apiKey'),
        data: [],
        paymentType: mainConfigService.get('payment_type'),
        lang: mainConfigService.get('lang'),
      });
      await Selector.jazzIntegration.init();
    }

    cards.forEach((card, index) => {
      if (card.cvv_required) {
        Selector.jazzIntegration.createCvvIframe({
          containerId: `token${index}${elements.cvvIframe}`,
          iframeName: `token${index}`,
          postData: card
        });
      }
    });
  }

  static async embedCardIframe(paymentMethods) {
    // Find first ottu_pg method to check if Jazz SDK is needed
    const hasJazzSDKEnabled = checkFormsofPayments('jazz') && paymentMethods.some(
      (method) => method.flow === SDK_FOPS.OTTU_PG && method.use_as_jazz_sdk
    );

    // If there's an ottu_pg method and it has use_as_jazz_sdk true, initialize Jazz SDK
    if (hasJazzSDKEnabled && !Selector.jazzIntegration) {
      Selector.jazzIntegration = new JazzIntegration({
        selector: Selector,
        callBackService: Selector.callbackService,
        fieldsService: Selector.fieldsService,
        sessionId: mainConfigService.get('session_id'),
        merchantId: mainConfigService.get('merchant_id'),
        apiKey: mainConfigService.get('apiKey'),
        data: [],
        paymentType: mainConfigService.get('payment_type'),
        lang: mainConfigService.get('lang'),
      });
      await Selector.jazzIntegration.init();
    }

    // Create iframes only for ottu_pg methods that have use_as_jazz_sdk enabled
    if (hasJazzSDKEnabled) {
      paymentMethods.forEach((method, index) => {
        if (method.flow === SDK_FOPS.OTTU_PG && method.use_as_jazz_sdk === true) {
          Selector.jazzIntegration.createCardIframe({
            containerId: `payment-method${index}${elements.cardIframe}`,
            iframeName: `payment-method${index}`,
            postData: method
          });
        }
      });
    }
  }

  static initLoyalty(data) {
    const qitafEntry = data.payment_services?.find(s => s.flow === SDK_FOPS.QITAF);
    const loyaltyConfig = qitafEntry
      ? {
        name: qitafEntry.label,
        phone: qitafEntry.customer_phone || '',
        currency_code: data.currency_code,
        code: qitafEntry.code,
        session_id: data.session_id,
        otp_url: qitafEntry.otp_url,
        reserve_url: qitafEntry.reserve_url,
        cancel_url: qitafEntry.cancel_url,
      }
      : null;

    if (!loyaltyConfig) return;

    const loyaltyBlockEl = Selector.documentCheckout.querySelector('#' + elements.loyaltyBlock);
    if (!loyaltyBlockEl) return;

    loyaltyBlockEl.innerHTML = loyaltySectionHtml(loyaltyConfig);
    loyaltyBlockEl.classList.remove('d-none');

    Selector.loyaltyService.init(
      { ...loyaltyConfig, total_amount: parseFloat(data.amount) || 0 },
      {
        onPayButtonStateChange: (shouldEnable) => Selector._onLoyaltyPayButtonStateChange(shouldEnable),
        onLoyaltyAmountChange: (walletAmount) => Selector._onLoyaltyAmountChange(walletAmount),
        onSdkStateUpdate: (payload) => Selector._onLoyaltySdkStateUpdate(payload),
        onCancelError: (message) => Selector.showModal(getFailedModalHtml(message, $t('Loyalty Redemption Cancel Failed')), null, 'info'),
      }
    );

    // Loyalty is offered, so the customer picks the method themselves: drop any selection
    // carried over from a previous render. `method` is a module singleton that survives
    // reload(), and the pay button gates on method.type rather than the DOM, so a stale
    // type would enable it with nothing visibly selected. This belongs here, once per
    // render, rather than in setEvents — setEvents re-runs each time a flex method's
    // availability resolves, and would clear the customer's own pick out from under them.
    // Nothing to unselect in the DOM yet either; the methods render later.
    method.type = '';
  }

  static async _loyaltySubmitPay() {
    const submitUrl = Selector.loyaltyService.getSubmitUrl();
    if (!submitUrl) return;
    Selector.fieldsService.disableEnableFields(true);
    try {
      await Selector.callbackService.callBackPayment();
      const res = await walletSubmitFetch(
        submitUrl,
        mainConfigService.get('apiKey'),
        Selector.loyaltyService.config.code,
        mainConfigService.get('session_id')
      );
      Selector.successResponse(res, SDK_FOPS.WALLET);
    } catch (err) {
      Selector.fieldsService.disableEnableFields(false);
      if (err.status >= 500) {
        err = {
          status: 'error',
          message:
            'Oops, something went wrong. Refresh the page and try again.',
        };
        Selector.callbackService.callBackError(err);
      } else {
        Selector.errorResponse(err);
      }
    }
  }

  static _onLoyaltyPayButtonStateChange(shouldEnable) {
    if (!Selector.documentCheckout.querySelector('#' + elements.payButton)) return;
    
    if (shouldEnable && Selector.loyaltyService.isConfirmed()) {
      Selector._setOtherMethodsDisabled(true);
      Selector._setPayButtonDisabled(false);
    } else if (shouldEnable && !Selector.loyaltyService.isConfirmed()) {
      Selector._setOtherMethodsDisabled(false);
      Selector._setPayButtonDisabled(!method.type);
    } else if (!shouldEnable && Selector.loyaltyService.isConfirmed()) {
      // Partial coverage — remaining amount is paid via the selected method.
      Selector._setPayButtonDisabled(!method.type);
    } else {
      Selector._setPayButtonDisabled(true);
    }
  }

  static _onLoyaltyAmountChange(reservation) {
    const amount       = mainConfigService.get('amount');
    const billing      = mainConfigService.get('billing');
    const currencyCode = Selector.loyaltyService.config.currency_code;
    const totalBlockEl = Selector.documentCheckout.querySelector('#' + elements.totalBlock);
    const headingEl    = Selector.documentCheckout.querySelector('.ottu__sdk-payment-details-heading-theme');
    if (!totalBlockEl) return;

    if (!reservation) {
      if (headingEl) headingEl.classList.remove('d-none');
      totalBlockEl.classList.remove('ottu__sdk-loyalty-billing-active');
      totalBlockEl.innerHTML = getTotalAmountHtml();
      Selector.changeTotal('', currencyCode, currencyCode, amount, '', billing);
      return;
    }

    // Config fallbacks cover a backend that omits the qitaf billing block; every
    // observed payload carries sub-total and fee on the reservation itself.
    const summaryCurrency = reservation.currencyCode || currencyCode;
    const subtotal  = reservation.subTotal ?? billing?.sub_total?.value ?? amount ?? 0;
    const fee       = reservation.fee ?? billing?.fee?.value ?? 0;
    const remaining = reservation.remainingAmount;

    if (headingEl) headingEl.classList.add('d-none');
    totalBlockEl.classList.add('ottu__sdk-loyalty-billing-active');
    totalBlockEl.innerHTML = loyaltyBillingSummaryHtml(
      subtotal,
      fee,
      reservation.walletAmount,
      remaining,
      summaryCurrency,
      Selector.loyaltyService.isFullCoverage()
    );
    Selector.changeTotal('', summaryCurrency, summaryCurrency, remaining, '', null);
  }

  static _onLoyaltySdkStateUpdate(payload) {
    if (!payload) return;
    mainConfigService.applyPayload(payload);
  }
}

exports.Selector = Selector;
